import React, { useEffect, useState } from 'react';
import { DropItem } from '../../components/asteroids/DropItem';
import Dropdown from '../../components/dropdown/dropdown.component';
import DateInput from '../../components/formComponents/DateInput.component';
import Container from '../../components/layout/container.component';
import mainApi from '../../redux/apis/main-api';
import './Stats.styles.scss';

const Statistics = () => {
	const [data, setData] = useState();
	const [selectedFilters, setSelectedFilters] = useState({ contract: '', selectedDate: new Date().toISOString().split('T')[0] });

	const getData = () => {
		mainApi.get('/APIS/getStatistics', { params: selectedFilters }).then((res) => {
			setData(res.data);
		});
	};

	useEffect(() => {
		console.log('CHANGE', selectedFilters);
		getData();
	}, [selectedFilters]);

	return (
		<div className="statistics">
			<Container>
				{data && (
					<>
						<div className="mainTitle">Game statistics</div>

						<div className="upper">
							<div className="card">
								<div className="head">Total games played today</div>
								<div className="value">{data.todayRows.games_played}</div>
							</div>

							<div className="card">
								<div className="head">Total played today </div>
								<div className="value">{Math.round(data.todayRows.seconds_played / 60)} min</div>
							</div>

							<Dropdown
								className="driverFilter"
								allowSelectNone
								noneSelectionTitle="All drivers"
								data={data.availableContracts}
								dataKey="contract"
								dataName="name"
								onChange={(e) => {
									setSelectedFilters({ ...selectedFilters, contract: e.target.value !== -1 ? e.target.value : '' });
								}}
							/>

							<DateInput
								value={selectedFilters.selectedDate}
								name="date"
								onValueChange={(e) => {
									setSelectedFilters({ ...selectedFilters, selectedDate: e.target.value });
								}}
							/>
						</div>

						<div className="subTitle">Daily highscores</div>

						<div className="dailyStats">
							<div className="head">
								<div>Contract</div>
								<div>Highscore</div>
								<div>Wallet</div>
								<div>Name</div>
							</div>

							<div className="stats">
								{data?.dailyRows.map((item, index) => {
									return (
										<div className="stat" key={index}>
											<div>{item.driver_contract_name}</div>
											<div>{item.highscore}</div>
											<div>{item.wallet}</div>
											<div>{item.name}</div>
										</div>
									);
								})}
							</div>
						</div>

						<div className="subTitle">Game history</div>

						<div className="statsList">
							<div className="head">
								<div>Date</div>
								<div>Minutes played</div>
								<div>Games played</div>
								<div>ORE Collected</div>
								<div>ORE Extracted</div>
								<div>ORE Extracted / seconds</div>
							</div>

							<div className="stats">
								{data?.gamesPerDayRows.map((item, index) => {
									return (
										<div className="stat" key={index}>
											<div>{item.started_formated}</div>
											<div>{parseFloat(item.seconds_played / 60).toFixed(2)}</div>
											<div>{item.games_played}</div>
											<div>{item.ore_collected}</div>
											<div>{item.ore_extracted}</div>
											<div>{item.ore_extracted_seconds}</div>
										</div>
									);
								})}
							</div>
						</div>
					</>
				)}
			</Container>
		</div>
	);
};

export default Statistics;
